export default __webpack_public_path__ + "static/americanabt_roman-f95495c0de01f564fe7c88e4b7203e46.woff2";